<script setup>
import { computed } from 'vue';

const props = defineProps({
    displayed: Boolean,
    animationDuration: String,
    icon: Boolean,
    text: String,
    link: String,
    linkText: String,
    linkEvent: String,
    actionLink: Boolean,
    value: {
        type: [Boolean, Number, String], // I have no idea and the showSnackbar function needs some serious refactoring
    },
    dislikeId: {
        type: [Boolean, Number, String], // I have no idea and the showSnackbar function needs some serious refactoring
    },
    company: {
        type: [Boolean, Number, String], // I have no idea and the showSnackbar function needs some serious refactoring
    },
});

const emit = defineEmits(['undo']);

const snackbarClass = computed(() => ({
    'k-c-snackbar': true,
    'm-snackbar': true,
    [`m-snackbar--${props.animationDuration}`]: props.displayed,
}));

const contentClass = computed(() => ({
    'k-c-snackbar__content': true,
    'k-c-snackbar__content--link': props.link,
}));

const linkClass = computed(() => ({
    'm-snackbar__link': true,
    'm-snackbar__link--action': props.actionLink,
}));

const snackbarStyle = computed(() => ({
    display: props.displayed ? '' : 'none',
}));

// TODO probably use function callback instead of event loopdieloop
function onLinkClick(event) {
    if (props.actionLink) {
        event.preventDefault();
        emit('undo', {
            value: props.value,
            dislikeId: props.dislikeId,
            company: props.company,
        });
    }
}
</script>

<template>
    <div
        :class="snackbarClass"
        :data-animation-duration="animationDuration"
        :style="snackbarStyle"
    >
        <template v-if="displayed">
            <div :class="contentClass">
                <template v-if="icon">
                    <svg
                        fill="currentColor"
                        class="k-c-snackbar__icon m-snackbar__icon"
                        viewBox="0 0 16 18"
                    >
                        <path
                            d="M5.76,14.01c-0.17,0-0.34-0.07-0.46-0.2L1.24,9.67C0.98,
                            9.42,0.99,9,1.25,8.75C1.5,8.5,1.91,8.51,2.16,8.76l3.59,3.67 l8.08-8.25c0.25-0.26,
                            0.66-0.26,0.92-0.01c0.26,0.25,0.26,0.66,0.01,0.92l-8.54,8.72C6.1,13.94,5.93,
                            14.01,5.76,14.01z"
                        />
                    </svg>
                </template>
                <span class="m-snackbar__infoText">{{ text }}</span>
                <template v-if="link">
                    <a
                        :class="linkClass"
                        :href="link"
                        :data-event="linkEvent"
                        @click="onLinkClick"
                    >{{ linkText }}</a>
                </template>
            </div>
        </template>
    </div>
</template>

<style lang="scss">
@use "styles";
</style>
